/* eslint-disable no-lonely-if */
/* eslint-disable react/no-array-index-key */
/* eslint no-underscore-dangle: ["error", { "allow": [ "_id"] }] */

import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import {
  Card,
  CardContent,
  // CardActions,
  CardHeader,
  // InputAdornment,
  // IconButton,
  // MenuItem,
  Button,
  CircularProgress,
  Grid,
  TextField
} from '@mui/material';
// import { ExpandMore } from '@mui/icons-material';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import SettingAction from '../../../store/actions/SettingAction';
import ContentLoader from '../../../utils/errorPages/ContentLoader';
// import { ValidateClover } from '../../../assets/validation';
import useHasPermission from '../../../utils/useHasPermission';
import { paymentSettings, index, store } from '../../../utils/constants';
import IOSSwitchStyle from '../../../components/SwitchField';

export default function PaymentClover() {
  const [data, setData] = useState([]);
  const [modeValue, setModeValue] = useState('');

  const dispatch = useDispatch();
  const { cloverData, isLoading } = useSelector((state) => state.setting); // Replace 'data' with your reducer name

  useEffect(() => {
    dispatch(SettingAction.getClover());
  }, [dispatch]);

  useEffect(() => {
    if (cloverData && cloverData?.data) {
      setData(cloverData.data);
      if (cloverData.data?.CLOVER_MODE) {
        setModeValue(cloverData.data.CLOVER_MODE);
      }
    }
  }, [cloverData]);

  const getDirtyValues = (values, initialObject) => {
    const newdata = { ...values };
    const keyValues = Object.keys(newdata);

    const dirtyValues = keyValues.filter(
      (keyValue) => newdata[keyValue] !== initialObject[keyValue]
    );

    keyValues.forEach((key) => {
      if (!dirtyValues.includes(key)) delete newdata[key];
    });
    return newdata;
  };

  const initialValues = {
    CLOVER_MODE: data?.CLOVER_MODE ?? '',
    CLOVER_SANDBOX_MERCHANT_ID: data?.CLOVER_SANDBOX_MERCHANT_ID ?? '',
    CLOVER_SANDBOX_PRIVATE_KEY: data?.CLOVER_SANDBOX_PRIVATE_KEY ?? '',
    CLOVER_SANDBOX_PUBLIC_KEY: data?.CLOVER_SANDBOX_PUBLIC_KEY ?? '',
    CLOVER_LIVE_MERCHANT_ID: data?.CLOVER_LIVE_MERCHANT_ID ?? '',
    CLOVER_LIVE_PUBLIC_KEY: data?.CLOVER_LIVE_PUBLIC_KEY ?? '',
    CLOVER_LIVE_PRIVATE_KEY: data?.CLOVER_LIVE_PRIVATE_KEY ?? '',
    CLOVER_IS_ENABLED: data?.CLOVER_IS_ENABLED
  };

  const permissionAccess = !(
    useHasPermission(paymentSettings, index) && useHasPermission(paymentSettings, store)
  );

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper">
      {isLoading ? <ContentLoader /> : ''}
      <Formik
        initialValues={initialValues}
        enableReinitialize
        // validationSchema={ValidateClover}
        onSubmit={(values, { setErrors, setSubmitting }) => {
          console.log(values, 'values');
          const updateValues = getDirtyValues(values, initialValues);
          dispatch(SettingAction.updateClover(updateValues, setErrors, setSubmitting));
        }}
      >
        {({
          errors,
          touched,
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          handleReset,
          isSubmitting,
          setFieldValue
        }) => (
          <form onSubmit={handleSubmit}>
            <Card>
              <CardContent>
                <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                  <Grid item lg={3} xl={2}>
                    <FormControl sx={{ mt: 2, width: '100%', textAlign: 'left' }}>
                      <FormLabel id="statusId" required={!permissionAccess}>
                        Clover Mode
                      </FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="statusId-label"
                        name="CLOVER_MODE"
                        value={values.CLOVER_MODE}
                        onChange={(e) => {
                          setFieldValue('CLOVER_MODE', e.target.value);
                          setModeValue(e.target.value);
                        }}
                      >
                        <FormControlLabel
                          // disabled={permissionAccess}
                          value="sandbox"
                          control={<Radio />}
                          label="Sandbox"
                        />
                        <FormControlLabel
                          // disabled={permissionAccess}
                          value="live"
                          control={<Radio />}
                          label="Live"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item lg={3} xl={3}>
                    <FormControl sx={{ mt: 2, width: '100%', textAlign: 'left' }}>
                      <FormLabel id="statusId" required={!permissionAccess} sx={{ mb: 1 }}>
                        Status
                      </FormLabel>
                      <IOSSwitchStyle
                        size="small"
                        disabled={permissionAccess}
                        checked={values.CLOVER_IS_ENABLED === 1}
                        value={values.CLOVER_IS_ENABLED}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setFieldValue('CLOVER_IS_ENABLED', 1);
                          } else {
                            setFieldValue('CLOVER_IS_ENABLED', 2);
                          }
                        }}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
                {modeValue === 'sandbox' ? (
                  <Card sx={{ mt: 2, maxWidth: '100%' }}>
                    <CardHeader
                      sx={{ textAlign: 'left !important' }}
                      title="Sandbox Configuration"
                    />
                    <CardContent>
                      <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                        <Grid item lg={4} xl={4}>
                          <TextField
                            error={
                              errors.CLOVER_SANDBOX_MERCHANT_ID &&
                              touched.CLOVER_SANDBOX_MERCHANT_ID
                            }
                            label="Clover Sandbox Merchant ID"
                            className=""
                            fullWidth
                            type="text"
                            name="CLOVER_SANDBOX_MERCHANT_ID"
                            value={values.CLOVER_SANDBOX_MERCHANT_ID}
                            // maxRows={4}
                            disabled={permissionAccess}
                            placeholder="Enter Merchant ID"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={
                              errors.CLOVER_SANDBOX_MERCHANT_ID &&
                              touched.CLOVER_SANDBOX_MERCHANT_ID &&
                              errors.CLOVER_SANDBOX_MERCHANT_ID
                            }
                            margin="normal"
                            variant="outlined"
                            required={false}
                            InputLabelProps={{ required: !permissionAccess }}
                          />
                        </Grid>
                        <Grid item lg={4} xl={4}>
                          <TextField
                            error={
                              errors.CLOVER_SANDBOX_PRIVATE_KEY &&
                              touched.CLOVER_SANDBOX_PRIVATE_KEY
                            }
                            label="Clover Sandbox Private Key"
                            className=""
                            fullWidth
                            type="text"
                            name="CLOVER_SANDBOX_PRIVATE_KEY"
                            value={values.CLOVER_SANDBOX_PRIVATE_KEY}
                            // maxRows={4}
                            disabled={permissionAccess}
                            placeholder="Enter Private Key"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={
                              errors.CLOVER_SANDBOX_PRIVATE_KEY &&
                              touched.CLOVER_SANDBOX_PRIVATE_KEY &&
                              errors.CLOVER_SANDBOX_PRIVATE_KEY
                            }
                            margin="normal"
                            variant="outlined"
                            required={false}
                            InputLabelProps={{ required: !permissionAccess }}
                          />
                        </Grid>
                        <Grid item lg={4} xl={4}>
                          <TextField
                            error={
                              errors.CLOVER_SANDBOX_PUBLIC_KEY && touched.CLOVER_SANDBOX_PUBLIC_KEY
                            }
                            label="Clover Sandbox Public Key"
                            className=""
                            fullWidth
                            disabled={permissionAccess}
                            type="text"
                            name="CLOVER_SANDBOX_PUBLIC_KEY"
                            value={values.CLOVER_SANDBOX_PUBLIC_KEY}
                            // maxRows={4}
                            placeholder="Enter Public Key"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={
                              errors.CLOVER_SANDBOX_PUBLIC_KEY &&
                              touched.CLOVER_SANDBOX_PUBLIC_KEY &&
                              errors.CLOVER_SANDBOX_PUBLIC_KEY
                            }
                            margin="normal"
                            variant="outlined"
                            required={false}
                            InputLabelProps={{ required: !permissionAccess }}
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                ) : (
                  <Card sx={{ mt: 2, maxWidth: '100%' }}>
                    <CardHeader sx={{ textAlign: 'left !important' }} title="Live Configuration" />
                    <CardContent>
                      <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                        <Grid item lg={4} xl={4}>
                          <TextField
                            error={
                              errors.CLOVER_LIVE_MERCHANT_ID && touched.CLOVER_LIVE_MERCHANT_ID
                            }
                            label="Clover Live Merchant ID"
                            className=""
                            fullWidth
                            type="text"
                            name="CLOVER_LIVE_MERCHANT_ID"
                            value={values.CLOVER_LIVE_MERCHANT_ID}
                            // maxRows={4}
                            disabled={permissionAccess}
                            placeholder="Enter Merchant ID"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={
                              errors.CLOVER_LIVE_MERCHANT_ID &&
                              touched.CLOVER_LIVE_MERCHANT_ID &&
                              errors.CLOVER_LIVE_MERCHANT_ID
                            }
                            margin="normal"
                            variant="outlined"
                            required={false}
                            InputLabelProps={{ required: !permissionAccess }}
                          />
                        </Grid>
                        <Grid item lg={4} xl={4}>
                          <TextField
                            id="CLOVER_LIVE_PUBLIC_KEY"
                            fullWidth
                            type="text"
                            label="Clover Live Private Key"
                            name="CLOVER_LIVE_PUBLIC_KEY"
                            margin="normal"
                            placeholder="Enter Private Key"
                            value={values.CLOVER_LIVE_PUBLIC_KEY}
                            onChange={handleChange}
                            disabled={permissionAccess}
                            onBlur={(e) => {
                              const val = (e.target.value || '').replace(/\s+/gi, '');
                              setFieldValue(e.target.name, val.trim());
                              handleBlur(e);
                            }}
                            error={errors.CLOVER_LIVE_PUBLIC_KEY && touched.CLOVER_LIVE_PUBLIC_KEY}
                            helperText={
                              errors.CLOVER_LIVE_PUBLIC_KEY &&
                              touched.CLOVER_LIVE_PUBLIC_KEY &&
                              errors.CLOVER_LIVE_PUBLIC_KEY
                            }
                            required={false}
                            InputLabelProps={{ required: !permissionAccess }}
                            // InputProps={{
                            //   endAdornment: (
                            //     <InputAdornment position="start">
                            //       <IconButton aria-label="toggle password visibility" edge="end" disabled>
                            //         <MailOutlineOutlinedIcon />
                            //       </IconButton>
                            //     </InputAdornment>
                            //   )
                            // }}
                          />
                        </Grid>
                        <Grid item lg={4} xl={4}>
                          <TextField
                            error={
                              errors.CLOVER_LIVE_PRIVATE_KEY && touched.CLOVER_LIVE_PRIVATE_KEY
                            }
                            label="Clover Live Public Key"
                            className=""
                            fullWidth
                            name="CLOVER_LIVE_PRIVATE_KEY"
                            value={values.CLOVER_LIVE_PRIVATE_KEY}
                            disabled={permissionAccess}
                            type="text"
                            // maxRows={4}
                            placeholder="Enter Public Key"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={
                              errors.CLOVER_LIVE_PRIVATE_KEY &&
                              touched.CLOVER_LIVE_PRIVATE_KEY &&
                              errors.CLOVER_LIVE_PRIVATE_KEY
                            }
                            margin="normal"
                            variant="outlined"
                            required={false}
                            InputLabelProps={{ required: !permissionAccess }}
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                )}
              </CardContent>
              {!permissionAccess ? (
                <CardContent
                  sx={{
                    backgroundColor: 'rgba(0, 0, 0, 0.06)',
                    p: 2,
                    columnGap: '16px',
                    display: 'flex',
                    justifyContent: 'center'
                  }}
                >
                  <Button
                    type="submit"
                    className="save__btn"
                    variant="contained"
                    color="secondary"
                    // fullWidth
                    disabled={isSubmitting}
                    size="medium"
                  >
                    {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                  </Button>
                  <Button
                    type="button"
                    className="cancel__btn"
                    variant="contained"
                    color="info"
                    size="medium"
                    onClick={() => {
                      handleReset();
                      setModeValue(data?.CLOVER_MODE);
                    }}
                  >
                    Clear
                  </Button>
                </CardContent>
              ) : (
                ''
              )}
            </Card>
          </form>
        )}
      </Formik>
    </Box>
  );
}
